module.exports = "/build/web/svg/event/verjaardag.afe5faef5038e45e0ed98292ac441508.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/event/verjaardag.svg
// module id = 163
// module chunks = 24